@if (!isIframe) {
    <router-outlet></router-outlet>

    <p-toast position="top-center" key="new-version">
        <ng-template let-message #message>
            <div class="flex flex-col items-start" style="flex: 1">
                <div class="flex items-center gap-2">
                    <div>
                        <i class="fa-sharp fa-solid fa-circle-info"></i>
                    </div>
                    <span class="font-bold text-color">
                        {{ message.summary }}
                    </span>
                </div>
                <div class="font-medium text-lg my-4 text-color">
                    {{ message.detail }}                   
                </div>
            </div>
        </ng-template>
    </p-toast>
    <app-themes></app-themes>
    <lib-inactivity-feature-inactivity></lib-inactivity-feature-inactivity>
}